import useSyncDocumentTitle from '../hooks/use-sync-document-title';

export function LogicHooks() {
	useSyncDocumentTitle();

	return null;
}
